import { render } from "./AdditionalInformation.vue?vue&type=template&id=521bd910&scoped=true"
import script from "./AdditionalInformation.vue?vue&type=script&lang=js"
export * from "./AdditionalInformation.vue?vue&type=script&lang=js"

import "./AdditionalInformation.vue?vue&type=style&index=0&id=521bd910&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521bd910"]])

export default __exports__